module.exports = __webpack_public_path__ + "img/pi-2.0c8b34ab.jpeg";